import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useSteeringLevelsCapacityQuery as query } from "@/modules/admin/capacity/services/__generated__/useSteeringLevelsCapacityQuery.graphql"

const steeringLevelsCapacityQuery = graphql`
  query useSteeringLevelsCapacityQuery {
    steeringLevels {
      id
      level
      levelValue
      isAutomatic
      language
      waitingTime {
        minutesToWait
        status
      }
    }
  }
`

export function useSteeringLevelsCapacityQuery() {
  const data = useLazyLoadQuery<query>(
    steeringLevelsCapacityQuery,
    {},
    {
      fetchPolicy: "network-only",
    },
  )

  return data
}
